import { useThdCustomer } from '@thd-olt-functional/customer-information';
import React from 'react';
import { useLocation } from 'react-router-dom';
import { useCommonContext, useExperienceContext, } from '../../hooks/useContexts';
import { OrderTrackingAndActions } from './delivery-tracker/OrderTrackingAndActions';
import { isReturnOnlineAllowed } from './util/DeliveryHelper';
import { getOrderActionEligibility } from './util/FulfillmentStatus';
import { isGiftCardInFulfillmentGroup } from './util/general';
/**
 * Searches in `lineItem.actions` first to see if every line item has the corresponding flag and if not...
 * searches in `fullfillmentGroup.actions` and if not defined...
 * searches in `oredeDetails.actions` to see if defined or key present
 * @param data Contains an object with `orderDetailsData` and `fulfillmentGroup`
 * @param action The required action to extract from `actions` object (present in `OrderDetails`, `FulfillmentGroup` or `LineItems`)
 * @returns the value of the action flag
 */
// TODO: Replace Luxon's DateTime.local().toLocaleString(DateTime.DATE_HUGE) with Day.js equivalent
// const formattedDate = dayjs().format('MMMM D, YYYY');
var isActionEnabled = function (data, action) {
    var orderDetails = data.orderDetails, fulfillmentGroup = data.fulfillmentGroup;
    // search in lineItems
    if (fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.lineItems) {
        if (fulfillmentGroup.lineItems.every(function (item) { return (item.actions && action in item.actions) || action in item; })) {
            return fulfillmentGroup.lineItems.every(function (lineItem) {
                var _a;
                return ((_a = lineItem === null || lineItem === void 0 ? void 0 : lineItem.actions) === null || _a === void 0 ? void 0 : _a[action]) === true ||
                    (lineItem === null || lineItem === void 0 ? void 0 : lineItem[action]) === true;
            });
        }
    }
    // search in fulfillmentGroup
    var actions = fulfillmentGroup.actions;
    if (actions && action in actions) {
        return actions[action] === true;
    }
    // search in orderDetails level
    actions = orderDetails.actions;
    if (actions && action in actions) {
        return actions[action] === true;
    }
    return false;
};
export var DeliveryComponent = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
    var fulfillmentGroup = _a.fulfillmentGroup, handleCancelEligibilityResult = _a.handleCancelEligibilityResult, handleEditDeliveryInstructions = _a.handleEditDeliveryInstructions, orderDetailsData = _a.orderDetailsData, shipmentIndex = _a.shipmentIndex, isFirstShipment = _a.isFirstShipment, setShowDrawerError = _a.setShowDrawerError, customerType = _a.customerType, setAvailableSlotsError = _a.setAvailableSlotsError, setPickupPersonState = _a.setPickupPersonState, setPickupPersonFraudError = _a.setPickupPersonFraudError, deliveryTrackerData = _a.deliveryTrackerData, fulfillmentGroupIndex = _a.fulfillmentGroupIndex, deliveryTrackerLoaded = _a.deliveryTrackerLoaded;
    var location = useLocation();
    var _u = useThdCustomer(), isLoggedIn = _u.isLoggedIn, isExchangeCustomer = _u.isExchangeCustomer;
    var isMobile = useCommonContext().isMobile;
    var isConsumerApp = useExperienceContext().isConsumerApp;
    var isNativeApp = isConsumerApp || false;
    var orderStatusCodes = [];
    if (orderDetailsData.cancellationRequested) {
        orderDetailsData.fulfillmentGroups.forEach(function (group) {
            var _a;
            (_a = group.lineItems) === null || _a === void 0 ? void 0 : _a.forEach(function (item) {
                var _a;
                orderStatusCodes.push((_a = item === null || item === void 0 ? void 0 : item.statusCode) !== null && _a !== void 0 ? _a : '');
            });
        });
    }
    // Check if it's necessary to iterate through LineItems to check the deliver status for each group
    // instead of using the general code status for the whole order ⬇️
    var statusCode = (_d = (_c = (_b = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.lineItems) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.statusCode) !== null && _d !== void 0 ? _d : 0;
    var actionData = { orderDetails: orderDetailsData, fulfillmentGroup: fulfillmentGroup };
    var reschedulable = (_g = (_f = (_e = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.shippingAndHandling) === null || _e === void 0 ? void 0 : _e.applianceDeliveries) === null || _f === void 0 ? void 0 : _f[0]) === null || _g === void 0 ? void 0 : _g.isRescheduleEnabled;
    var isDfsReschedulable = isActionEnabled(actionData, 'isRescheduleEnabled');
    var _v = getOrderActionEligibility(fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.fulfillmentType, statusCode), isEligibleFulfillmentAAFESOrNex = _v.isEligibleFulfillmentAAFESOrNex, isRescheduleEligibleForMAorBODFSorDFS = _v.isRescheduleEligibleForMAorBODFSorDFS, fulfillmentTypeEligibleForReturn = _v.fulfillmentTypeEligibleForReturn;
    var isAAFESOrNexOrder = (orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.isAAFESOrder) || (orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.isNEXOrder);
    var actions = {
        ereceiptBuyAgain: true,
        isCancelEnabled: !fulfillmentGroup.isPostRemorse &&
            ((_h = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.actions) === null || _h === void 0 ? void 0 : _h.isCancelEnabled),
        isLineItemCancelEnabled: !fulfillmentGroup.isPostRemorse &&
            ((_j = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.actions) === null || _j === void 0 ? void 0 : _j.isCancelEnabled) &&
            ((_k = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.actions) === null || _k === void 0 ? void 0 : _k.isLineItemCancelEnabled),
        isEditPickupPersonEnabled: (_l = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.actions) === null || _l === void 0 ? void 0 : _l.isEditPickupPersonEnabled,
        isDFSRescheduleEnabled: isDfsReschedulable,
        isLineHaul: true,
        isPostRemorseCancelEnabled: (fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.isPostRemorse) &&
            ((_m = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.actions) === null || _m === void 0 ? void 0 : _m.isCancelEnabled),
        isStatusDetails: true,
        isSubscriptionEligible: true,
        reschedule: reschedulable,
        returnOnlineAllowed: isReturnOnlineAllowed(fulfillmentGroup),
        showETAmessage: true,
        viewCustomDetails: true,
        writeAReview: isActionEnabled(actionData, 'writeAReview'),
        isEditDeliveryInstructionsEnabled: (_o = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.actions) === null || _o === void 0 ? void 0 : _o.isEditDeliveryInstructionsEnabled,
        isEditSiteInstructionsEnabled: (_p = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.actions) === null || _p === void 0 ? void 0 : _p.isEditSiteInstructionsEnabled,
        isEditPickupLocationEnabled: (_q = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.actions) === null || _q === void 0 ? void 0 : _q.isEditPickupLocationEnabled,
        isEditDeliveryAddressEnabled: (_r = fulfillmentGroup.actions) === null || _r === void 0 ? void 0 : _r.isEditDeliveryAddressEnabled,
        isBopisOutOfStockEnabled: false, // set to true to show button for local development of feature
    };
    var buttonSettings = {
        actions: actions,
        cancellationRequested: orderDetailsData.cancellationRequested,
        customerType: customerType,
        fulfillmentGroup: fulfillmentGroup,
        fulfillmentTypeEligibleForReturn: fulfillmentTypeEligibleForReturn,
        handleCancelEligibilityResult: handleCancelEligibilityResult,
        handleEditDeliveryInstructions: handleEditDeliveryInstructions,
        isAAFESOrNexOrder: isAAFESOrNexOrder,
        isEditDeliveryAddressEnabled: (_s = fulfillmentGroup.actions) === null || _s === void 0 ? void 0 : _s.isEditDeliveryAddressEnabled,
        isEditPickupLocationEnabled: (_t = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.actions) === null || _t === void 0 ? void 0 : _t.isEditPickupLocationEnabled,
        isEligibleFulfillmentAAFESOrNex: isEligibleFulfillmentAAFESOrNex,
        isFirstShipment: isFirstShipment,
        isGuestOrder: location.pathname === '/myaccount/guest-order-tracking',
        isLoggedIn: isLoggedIn,
        isExchangeCustomer: isExchangeCustomer,
        isMobile: isMobile,
        isNativeApp: isNativeApp,
        isRescheduleEligibleForMAorBODFSorDFS: isRescheduleEligibleForMAorBODFSorDFS,
        location: location.pathname,
        orderDetailsData: orderDetailsData,
        setAvailableSlotsError: setAvailableSlotsError,
        setShowDrawerError: setShowDrawerError,
        setPickupPersonFraudError: setPickupPersonFraudError,
        setPickupPersonState: setPickupPersonState,
        shipmentIndex: shipmentIndex,
        statusCode: statusCode,
        fulfillmentGroupIndex: fulfillmentGroupIndex,
    };
    return (React.createElement("div", { className: "sui-flex sui-flex-col sui-order-1 md:sui-order-2 sui-mb-4" }, !isGiftCardInFulfillmentGroup(fulfillmentGroup) && (React.createElement(OrderTrackingAndActions, { buttonSettings: buttonSettings, fulfillmentGroup: fulfillmentGroup, deliveryTrackerData: deliveryTrackerData, deliveryTrackerLoaded: deliveryTrackerLoaded }))));
};
